import { useEffect, useState } from "react";
const useMessageTimer = () => {
    const [showCopiedToClipboardMessage, setShowCopiedToClipboardMessage] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            showCopiedToClipboardMessage && setShowCopiedToClipboardMessage(false);
        }, 3000);
        return () => {
            clearTimeout(timer);
        };
    }, [showCopiedToClipboardMessage]);
    return [showCopiedToClipboardMessage, setShowCopiedToClipboardMessage];
};
export default useMessageTimer;
